import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SectionStyle = styled.section`
    display: block;
    padding: 20px 25px;
    clear: both;
    font-size: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    label {
        text-align: center;
        font-weight: bold;
    }
    p {
        display: inline-block;
        text-indent: 0px;
        font-size: 20px;
        line-height: 20px;
    }
    .styled-radio {
        input[type='radio'] {
            display: none;
        }
        input[type='radio']:checked + label:after {
            opacity: 1;
        }
        label {
            position: relative;
            margin-left: 40px;
            margin-right: 20px;
            cursor: pointer;
            &:after {
                display: block;
                content: '';
                position: absolute;
                left: -22px;
                top: 6px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #000;
                opacity: 0;
                -webkit-transition: opacity 0.5s;
                transition: opacity 0.5s;
                box-sizing: border-box;
            }
            &:before {
                left: -30px;
                top: -2px;
                width: 26px;
                height: 26px;
                border-width: 3px;
                content: '';
                position: absolute;
                left: -30px;
                border-radius: 50%;
                border-style: solid;
                background-color: transparent;
                border-color: #000;
                box-sizing: border-box;
            }
        }
    }
    ${props =>
        props.valid &&
        `
  .styled-radio {
    
    label {
      
      &:before {
        
        border-color: red;
      }
    }
  }
  `};
`

export default class TSection extends React.Component {
    render() {
        if(this.props.noInput === "true"){
            return (
                <SectionStyle >
                    <label>{this.props.children}</label>
                </SectionStyle>
            )
        }
        return (
            <SectionStyle valid={this.props.valid}>
                <label>{this.props.children}</label>
                <div className="styled-radio">
                    <p>
                        <input
                            type="radio"
                            id={`${this.props.name}-yes`}
                            value="1"
                            name={this.props.name}
                            onChange={this.props.onChange}
                        />
                        <label htmlFor={`${this.props.name}-yes`}>Ja</label>
                    </p>
                    {(this.props.inputtwodisabled === 'undefined' ||
                        this.props.inputtwodisabled !== 'disabled') && (
                        <p>
                            <input
                                type="radio"
                                id={`${this.props.name}-no`}
                                value="0"
                                name={this.props.name}
                                onChange={this.props.onChange}
                                disabled={this.props.inputtwodisabled && true}
                            />
                            <label htmlFor={`${this.props.name}-no`}>Nej</label>
                        </p>
                    )}
                </div>
            </SectionStyle>
        )
    }
}

TSection.propTypes = {
    valid: PropTypes.string,
    children: PropTypes.node,
    name: PropTypes.string,
    onChange: PropTypes.func,
    inputtwodisabled: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/component/tsection.js